import { Session } from '@ory/kratos-client';
import {
  FrontendApiGetRecoveryFlowRequest,
  FrontendApiUpdateLoginFlowRequest,
  FrontendApiUpdateRegistrationFlowRequest,
  FrontendApiUpdateRecoveryFlowRequest,
  FrontendApiUpdateSettingsFlowRequest,
  SuccessfulNativeRegistration,
  LoginFlow,
  RegistrationFlow,
  RecoveryFlow,
  SettingsFlow,
  SuccessfulNativeLogin,
  VerificationFlow,
  FrontendApiGetVerificationFlowRequest,
  FrontendApiUpdateVerificationFlowRequest,
  FrontendApiCreateBrowserLoginFlowRequest,
  FrontendApiCreateBrowserRecoveryFlowRequest,
  FrontendApiCreateBrowserRegistrationFlowRequest,
  FrontendApiGetRegistrationFlowRequest,
  FrontendApiGetLoginFlowRequest,
  FlowError,
} from '@ory/kratos-client/api';
import { apiClient } from 'common/clients/api.client.ts';
import { kratosClient } from 'common/clients/kratos.client.ts';
import { setHttps } from 'common/utils/url.utils.ts';
import { EAction } from 'domains/auth/enums/auth.enums.ts';
import { IDataResp } from 'domains/auth/interfaces/auth.interfaces.ts';

export const authCreateLoginFlowService = async (
  params: FrontendApiCreateBrowserLoginFlowRequest
): Promise<LoginFlow> => {
  const { data } = await kratosClient.createBrowserLoginFlow(params);

  return data;
};

export const authUpdateLoginFlowService = async (
  reqData: FrontendApiUpdateLoginFlowRequest
): Promise<SuccessfulNativeLogin> => {
  const { data } = await kratosClient.updateLoginFlow(reqData);

  return data;
};

export const authGetLoginFlowService = async (
  reqData: FrontendApiGetLoginFlowRequest
): Promise<LoginFlow> => {
  const { data } = await kratosClient.getLoginFlow(reqData);

  return data;
};

export const authGetRegistrationFlowService = async (
  reqData: FrontendApiGetRegistrationFlowRequest
): Promise<RegistrationFlow> => {
  const { data } = await kratosClient.getRegistrationFlow(reqData);

  return data;
};

export const authCreateRegistrationFlowService = async (
  params: FrontendApiCreateBrowserRegistrationFlowRequest
): Promise<RegistrationFlow> => {
  const { data } = await kratosClient.createBrowserRegistrationFlow(params);

  return data;
};

export const authUpdateRegistrationFlowService = async (
  reqData: FrontendApiUpdateRegistrationFlowRequest
): Promise<SuccessfulNativeRegistration> => {
  const { data } = await kratosClient.updateRegistrationFlow(reqData);

  return data;
};

export const authGetVerificationFlowService = async (
  reqData: FrontendApiGetVerificationFlowRequest
): Promise<VerificationFlow> => {
  const { data } = await kratosClient.getVerificationFlow(reqData);

  return data;
};

export const authUpdateVerificationFlowService = async (
  reqData: FrontendApiUpdateVerificationFlowRequest
): Promise<VerificationFlow> => {
  const response = await kratosClient.updateVerificationFlow(reqData);

  return response.data;
};

export const authCreateRecoveryFlowService = async (
  params: FrontendApiCreateBrowserRecoveryFlowRequest
): Promise<RecoveryFlow> => {
  const { data } = await kratosClient.createBrowserRecoveryFlow(params);

  return data;
};

export const authUpdateRecoveryFlowService = async (
  reqData: FrontendApiUpdateRecoveryFlowRequest
): Promise<RecoveryFlow> => {
  const response = await kratosClient.updateRecoveryFlow(reqData);

  return response.data;
};

export const authGetRecoveryFlowService = async (
  reqData: FrontendApiGetRecoveryFlowRequest
): Promise<RecoveryFlow> => {
  const { data } = await kratosClient.getRecoveryFlow(reqData);

  return data;
};

export const authGetSettingsFlowService = async (flowId: string): Promise<SettingsFlow> => {
  const { data } = await kratosClient.getSettingsFlow({ id: flowId });

  return data;
};

export const authCreateSettingsFlowService = async (): Promise<SettingsFlow> => {
  const { data } = await kratosClient.createBrowserSettingsFlow();

  return data;
};

export const authUpdateSettingsFlowService = async (
  reqData: FrontendApiUpdateSettingsFlowRequest
): Promise<SettingsFlow> => {
  const { data } = await kratosClient.updateSettingsFlow(reqData);

  return data;
};

export const authToSessionService = async (): Promise<Session> => {
  const { data } = await kratosClient.toSession();

  return data;
};

export const authLogoutFlowService = async (): Promise<{ logoutUrl: string; }> => {
  const reParams = {
    returnTo: window.location.href,
  };
  const { data: logoutFlow } = await kratosClient.createBrowserLogoutFlow(reParams);

  // if (!logoutFlow.logout_url) {
  //   const reParams = {
  //     token: logoutFlow.logout_token,
  //     // returnTo: window.location.href,
  //   };
  //   await kratosClient.updateLogoutFlow(reParams);
  // }

  return {
    logoutUrl: logoutFlow.logout_url || '',
  };
};

export const logoutFlowProtocol = async (): Promise<void> => {
  // Async request shouldn't block code below
  let logoutUrl = '';

  try {
    ({ logoutUrl } = await authLogoutFlowService());
  } catch (e) {
    console.error(e);
  }

  try {
    if (logoutUrl) {
      window.location.href = logoutUrl;
    }
  } catch (error) {
    console.error(error);
  }
};

export const getFlowErrorService = async (errorId: string): Promise<FlowError> => {
  const { data } = await kratosClient.getFlowError({ id: errorId });

  return data;
};

export const lightWalkThroughInteractiveService = async (url: string): Promise<IDataResp> => {
  const { data } = await apiClient.get<IDataResp>(url);

  return data;
};

export const authStartRecursivelyInteractiveService = async (url: string): Promise<void> => {
  try {
    const { url: nextUrl, action } = await lightWalkThroughInteractiveService(url);

    if (nextUrl && action === EAction.Finish) {
      window.location.replace(setHttps(nextUrl));
    } else if (nextUrl) {
      await authStartRecursivelyInteractiveService(`${nextUrl}?redirect=false`);
    }
  } catch (error) {
    throw new Error(error as string);
  }
};
